import React, {useState, useCallback} from 'react';
import {useSelector} from 'react-redux';
import SubmitButton from './SubmitButton';
import LoadingIndicator from '../../../../../../../Common/LoadingIndicator/LoadingIndicator';
import AccessButtons from './AccessButtons';
import {getLastSectionByDocumentId} from '../../../../../../../../selectors/Ares/selectors';
import {useAresUrlParameters} from '../../../../../../../../util/Ares/customHooks';

export default function IndivualIndependenceFooter(props) {
	const {document} = props;

	const [isLoading, setIsLoading] = useState(false);
	const [disableButton, setDisableButton] = useState(false);

	const showLoading = useCallback((isLoading) => setIsLoading(isLoading), []);

	const lastFormSection = useSelector((store) => getLastSectionByDocumentId(store, document.id));
	const {sectionId} = useAresUrlParameters();

	const isLastSection = lastFormSection?.id === sectionId;

	return (
		<React.Fragment>
			{isLastSection && (
				<React.Fragment>
					{isLoading ? (
						<LoadingIndicator show fullscreen styleName="LoadingIndicator IndivualIndependenceFooter" />
					) : (
						<React.Fragment>
							<SubmitButton
								{...props}
								showLoading={showLoading}
								setDisableButton={setDisableButton}
								disableButton={disableButton}
							/>
							<AccessButtons doc={document} />
						</React.Fragment>
					)}
				</React.Fragment>
			)}
		</React.Fragment>
	);
}
